import { render, staticRenderFns } from "./congrats.vue?vue&type=template&id=7461d1a2&"
import script from "./congrats.vue?vue&type=script&lang=js&"
export * from "./congrats.vue?vue&type=script&lang=js&"
import style0 from "./congrats.vue?vue&type=style&index=0&id=7461d1a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports